export enum Token {
  Layer1 = 'Layer 1',
  Layer2 = 'Layer 2',
  Memecoin = 'Memecoin',
  NFT = 'NFT',
  Metaverse = 'Metaverse',
  SocialTokens = 'Social tokens',
  GameFi = 'GameFi',
  DeFi = 'DeFi',
  Restaking = 'Restaking',
  DePin = 'DePin',
  Oracles = 'Oracles',
  RWA = 'RWA',
  DataStorage = 'Data storage',
  AI = 'AI',
}

export const defaultToken = Token.Layer1